import { render } from "./CircleCanvas.vue?vue&type=template&id=19497b67"
import script from "./CircleCanvas.vue?vue&type=script&lang=js"
export * from "./CircleCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__